class ArticleFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.tagCheckboxes = [...this.querySelectorAll(".js-facet-checkbox")];
    this.categoryCheckboxes = [...this.querySelectorAll(".blog-filter-categories .js-facet-checkbox")];
    this.submitButton = this.querySelector(".js-filters-apply");
    this.activeTags = [...this.querySelectorAll(".js-active-tag")];
    this.clearButton = this.querySelector(".js-filters-clear");

    this.facetParent = this.closest(".facets-container");
    this.searchInput = this.facetParent.querySelector(".js-article-search-input");
    this.searchParent = this.facetParent.querySelector(".search");
    this.showSearchButton = this.facetParent.querySelector(".js-show-search-button");
    this.searchSubmit = this.facetParent.querySelector(".js-article-search-submit");
    this.blogHandle = this.dataset.blogHandle;

    this.filterTagsContainer = document.querySelector("article-filters-tags");
    if (this.filterTagsContainer) {
      this.activeTags = [...this.activeTags, ...this.filterTagsContainer.querySelectorAll(".js-active-tag")];
      this.filterTagsClearButton = this.filterTagsContainer.querySelector(".js-filters-clear");
    }

    this.categoryCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", () => {
        this.handleCategoryClick(checkbox);
      });
    });

    this.submitButton.addEventListener("click", (event) => this.handleSubmit(event));
    this.searchSubmit.addEventListener("click", (event) => this.handleSubmit(event));
    this.searchInput.addEventListener("keyup", (event) => {
      if (event.key === "Enter") this.handleSubmit(event);
    });

    this.activeTags.forEach((tag) => {
      tag.addEventListener("click", () => this.handleTagClick(tag));
    });

    this.clearButton?.addEventListener("click", () => this.clearFilters());
    this.filterTagsClearButton?.addEventListener("click", () => this.clearFilters(true));

    if (this.showSearchButton && this.searchParent) {
      this.showSearchButton.addEventListener("click", (event) => {
        this.showSearchButton.classList.add("hidden");
        this.searchParent.classList.remove("hidden");
        this.searchInput.focus();
      });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let redirectUrl = window.location.href.split("/tagged/")[0];

    const checkedTags = this.tagCheckboxes
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => {
        const andReplace = this.searchInput.value.length > 0 ? "%26" : "";
        return checkbox.value.replace("& ", andReplace).replace(/ /g, "-").replace(/--/g, "-").toLowerCase();
      })
      .join("+");

    const searchQuery = `${checkedTags} ${this.searchInput.value}`;

    if (this.searchInput.value.length > 0) {
      redirectUrl = window.Shopify.routes.root + "search?q=" + searchQuery + "&type=article";
    } else if (checkedTags) {
      redirectUrl += "/tagged/" + checkedTags + "?view=filtered";
    }

    window.location.href = redirectUrl;
  };

  handleCategoryClick = (category) => {
    const isChecked = category.checked;
    if (isChecked) {
      this.categoryCheckboxes.forEach((checkbox) => {
        if (isChecked && checkbox !== category) {
          checkbox.checked = false;
          checkbox.disabled = true;
          checkbox.closest(".facet-checkbox").classList.add("facet-checkbox--disabled");
        }
      });
    } else {
      this.tagCheckboxes.forEach((checkbox) => {
        checkbox.disabled = false;
        checkbox.closest(".facet-checkbox").classList.remove("facet-checkbox--disabled");
      });
    }
  };

  handleTagClick = (tag) => {
    const autoSubmit = tag.dataset.autoSubmit === "true";
    let tagCheckbox = this.tagCheckboxes.find((checkbox) => checkbox.value === tag.dataset.tag);
    if (tag.dataset.searchTag) {
      tagCheckbox = this.tagCheckboxes.find((checkbox) => checkbox.dataset.searchTag === tag.dataset.searchTag);
    }

    if (tagCheckbox) tagCheckbox.checked = false;

    this.activeTags.forEach((activeTag) => {
      if (activeTag.dataset.searchTag === tag.dataset.searchTag) activeTag.remove();
    });

    if (autoSubmit) {
      this.handleSubmit(new Event("click", { bubbles: true }));
    }
  };

  clearFilters = (autoSubmit) => {
    this.tagCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.disabled = false;
      checkbox.closest(".facet-checkbox").classList.remove("facet-checkbox--disabled");
    });
    this.activeTags.forEach((tag) => tag.remove());
    if (autoSubmit) {
      this.handleSubmit(new Event("click", { bubbles: true }));
    }
  };
}

customElements.define("article-filters-form", ArticleFiltersForm);
